<template>
  <div>
    <FilterOrganization :disable="false" @option="onOptionChange" :option="option"/>
    <CAlert v-if="errorMessage" color="danger" show>
      {{ errorMessage }}
    </CAlert>
    <TrainingDemandSummary
      class="mb-4"
      :summary="trainingDemand.summary"
      :year="option.year"
      :loading="loading"
    />
    <TrainingDemandCourses
      :items="trainingDemand.courses"
      :summary="trainingDemand.summary"
      :year="option.year"
      :loading="loading"
    />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import FilterOrganization from "@/projects/components/Filter/FilterOrganization";
import TrainingDemandSummary from "@/projects/views/E-Performances/Reports/training-demand/components/TrainingDemandSummary.vue";
import TrainingDemandCourses from "@/projects/views/E-Performances/Reports/training-demand/components/TrainingDemandCourses.vue";

export default {
  name: "RTrainingDemand",
  components: {TrainingDemandCourses, TrainingDemandSummary, FilterOrganization},

  data: function () {
    return {
      option: {
        organization: "66cbe802a41ed9362a8579fa",
        agency: 0,
        year: new Date().getFullYear() + 541,
      },
      loading: true,
      errorMessage: "",
    }
  },

  created() {
    this.onLoad();
  },

  methods: {
    createRequestBody() {
      const profile = this.profile || {};
      const body = {
        year: this.option.year,
        agency: this.option.agency,
        lang: this.lang
      };

      if (profile.role !== 1 && profile.agency && profile.agency._id) {
        body.agency = profile.agency._id;
      }

      return body;
    },

    async onLoad() {
      this.loading = true;
      this.errorMessage = "";

      try {
        await this.$store.dispatch("idpReport/trainingDemand", this.createRequestBody());
      } catch (error) {
        this.errorMessage = error && error.message ? error.message : "Failed to load training demand report";
      } finally {
        this.loading = false;
      }
    },

    onOptionChange(e) {
      this.option = e;
      this.onLoad();
    },
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      profile: "personal/profile",
      trainingDemand: "idpReport/trainingDemand",
    }),
  },

  watch: {
    lang() {
      this.onLoad();
    }
  }
}
</script>

<style scoped>

</style>
